import { createFileRoute } from "@tanstack/react-router"
import { SignDialog } from "./-components/sign-dialog"

export const Route = createFileRoute("/review/$token/sign")({
  component: SignDialog,
})
